module.exports = __webpack_public_path__ + "img/office.a22872f8.jpg";